import { handlePageView } from "./base";
import {
  handleLoginPromptCloseEvent,
  handleLoginPromptOpenEvent,
} from "./authentication";
import {
  handleNavigationPageView,
  handleSubCompetencyClick,
  handleShareLinkClick,
  handleOutboundClick,
  handleExternalResourceLinkClick,
  handleBackToNavigatorClick,
  handleActivityCardClick,
  handleNavLinkClick,
  handleActivitySlidesButtonsClick,
  handleActivityTileClick,
  handleCompetencyCardClick,
  handleInternalNavigationButtonClick,
  handleBreadcrumbNavigationClick,
  handleMapListViewToggleButtonClick,
  handleAccountNavLinkClick,
  handleDrawerClose,
  handleDrawerOpen,
  handleDrawerModalOpen,
  handleDrawerModalClose,
} from "./navigation";
import {
  handleSearchBarView,
  handleSearchResultClick,
  handleEmbeddedSearchRequest,
} from "./search";
import {
  handleAddActivityToSavedResourcesEvent,
  handleRemoveActivityFromSavedResourcesEvent,
  handleAddToSavedResourcesEvent,
  handleRemoveFromSavedResourcesEvent,
  handleSavedResourcesAccordionEvent,
  handleComponentSkillActivitySectionEvent,
  handleProjectCardDetailClick,
  handleViewProjectClick,
  handleProjectAdditionEvent,
  handleProjectExportEvent,
} from "./savedResources";
import { handleFilterEvent } from "./filter";

const Analytics = {
  handlePageView,
  handleNavigationPageView,
  handleSubCompetencyClick,
  handleShareLinkClick,
  handleOutboundClick,
  handleExternalResourceLinkClick,
  handleBackToNavigatorClick,
  handleSearchBarView,
  handleSearchResultClick,
  handleEmbeddedSearchRequest,
  handleActivityCardClick,
  handleNavLinkClick,
  handleActivitySlidesButtonsClick,
  handleActivityTileClick,
  handleCompetencyCardClick,
  handleInternalNavigationButtonClick,
  handleBreadcrumbNavigationClick,
  handleMapListViewToggleButtonClick,
  handleAddToSavedResourcesEvent,
  handleRemoveFromSavedResourcesEvent,
  handleAddActivityToSavedResourcesEvent,
  handleRemoveActivityFromSavedResourcesEvent,
  handleSavedResourcesAccordionEvent,
  handleComponentSkillActivitySectionEvent,
  handleProjectCardDetailClick,
  handleViewProjectClick,
  handleDrawerClose,
  handleDrawerOpen,
  handleAccountDropdownNavLinkClick: handleAccountNavLinkClick,
  handleFilterEvent,
  handleLoginPromptOpenEvent,
  handleLoginPromptCloseEvent,
  handleDrawerModalOpen,
  handleDrawerModalClose,
  handleProjectAdditionEvent,
  handleProjectExportEvent,
};

export default Analytics;
export { ClickActions } from "./navigation";
